import {AxiosError, AxiosResponse} from "axios";
import {Axios} from "../../../axiosHelper";
import {ResponseBase} from "../../data";
import {podActions} from "../../slice/efe/podSlice";
import {AddPodRequest, PodListResponse} from "../../data/pod";

export const getPodList = (companyId: number): any => {
  return async (dispatch: any) => {
    dispatch(podActions.setLoading(true));

    Axios.get(`efe/pod/list?companyId=${companyId}`)
      .then((res: AxiosResponse<PodListResponse>) => {
        dispatch(podActions.setPodList(res.data.podList));
      })
      .catch((err: AxiosError) => {
        if (err.response) {
          if (err.response.status === 400) {
            const resp: any = err.response.data;
            dispatch(podActions.setError(resp));
          }
        }
      });
  };
};

export const clearPodResponse = (): any => {
  return async (dispatch: any) => {
    dispatch(podActions.setResponse(null));
  };
};

export const clearPodError = (): any => {
  return async (dispatch: any) => {
    dispatch(podActions.setError(null));
  };
};

export const addNewPod = (request: AddPodRequest): any => {
  return async (dispatch: any) => {
    dispatch(podActions.setLoading(true));

    Axios.post("/efe/pod/new", request, {
      headers: {
        "Content-Type": "application/json"
      }
    })
        .then((res: AxiosResponse<ResponseBase>) => {
          dispatch(podActions.setResponse(res.data));
        })
        .catch((err: AxiosError) => {
          if (err.response) {
            if (err.response.status === 400) {
              const resp: any = err.response.data;
              dispatch(podActions.setError(resp));
            }
          }
        });
  };
};